import { render } from "./slides.vue?vue&type=template&id=5482bab6&scoped=true"
import script from "./slides.vue?vue&type=script&lang=js"
export * from "./slides.vue?vue&type=script&lang=js"

import "./slides.vue?vue&type=style&index=0&id=5482bab6&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5482bab6"]])

export default __exports__